// The Realm Survivor RPG game content sourced from the official Steam page.
// Developer & Publisher: Monarchy Knuckle Games.

export const GAME = {
  title: 'The Realm Survivor RPG',
  developer: 'Monarchy Knuckle Games',
  publisher: 'Monarchy Knuckle Games',
  release: 'Coming Soon',
  genres: ['Action', 'Adventure', 'RPG', 'Indie', 'Early Access'],
  steam: 'https://store.steampowered.com/app/4008180/The_Realm_Survivor_RPG/',
  tagline: 'Time no longer exists.',
  hook:
    "Fight in this urban open world RPG Beat 'em up survival game. Beat gangs, robots, ninjas, orcs, and many villains of the realms. Using bare fist, weapons, magic, meditation to stop your enemies. Take on mission acts, challenging tasks, the moral choice will matter in the end.",
  story: [
    'Dr Zega commands a fleet of time-traveler clones, sending them into present-day "Suburb City, Michigan" to rewrite the timeline and every other realm bending the entire universe to his demonic will.',
    'He has placed a bounty on Benard, the one survivor able to slip between realms and shape the universe himself. Cross dimensions to aid the corruption, neutralize the chaos, or answer the call and change the realms for the better.',
    'This is a 3rd / 1st person open-world survival beat \'em up. Every mission is a moral choice demonic, deviant or divine. You can even win without conflict at all. Choose wisely, Realm Survivor.',
  ],
};

export const FEATURES = [
  {
    icon: 'Globe',
    title: 'Travel the Realms',
    desc: 'Cross into wholly different realms, each with its own gameplay experience, UI, events and rules.',
  },
  {
    icon: 'Building2',
    title: 'Build an Empire',
    desc: 'Buy and build businesses from premade structures to generate wealth and shape the environment.',
  },
  {
    icon: 'MoonStar',
    title: 'Lost-Time Cycles',
    desc: 'Time is gone no clocks, only day and night. Survive the rhythm of each realm.',
  },
  {
    icon: 'Zap',
    title: 'Living Events',
    desc: 'Dynamic events play out across every realm. Some are richly rewarding, others deadly.',
  },
  {
    icon: 'Sparkles',
    title: 'Superhuman Abilities',
    desc: 'Super speed, teleporting, raw strength, fly-glide and more bend reality to your fists.',
  },
  {
    icon: 'Car',
    title: 'Travel Anything',
    desc: 'Roam by car, horse, spacecraft and more across sprawling open worlds.',
  },
  {
    icon: 'Users',
    title: 'AI Companions',
    desc: 'Recruit allies and fight alongside AI companionship on your journey.',
  },
  {
    icon: 'Hammer',
    title: 'Craft & Cultivate',
    desc: 'Crafting, farming, cooking, research materials, gems and flowers fuel your survival.',
  },
  {
    icon: 'Swords',
    title: 'Battle & TCG',
    desc: '1v1 RPG fighting battles plus 1v1 to 3v3 trading-card battle decks (TCG).',
  },
  {
    icon: 'Coins',
    title: 'Trade & Quest',
    desc: 'Buy and sell with vendors and side-quest NPCs to build your fortune.',
  },
  {
    icon: 'Trophy',
    title: 'Realm Sports',
    desc: 'Take a break with basketball, bowling and many other sports across the realms.',
  },
  {
    icon: 'Backpack',
    title: 'Inventory System',
    desc: 'A fixed, dependable inventory to manage gear, loot and crafted goods.',
  },
];

export const PATHS = [
  {
    tag: 'Demonic',
    color: 'blood',
    desc: 'Embrace the time-traveler\'s corruption and let the realms burn for power.',
  },
  {
    tag: 'Deviant',
    color: 'purple',
    desc: 'Walk the line. Neutralize the chaos and survive on your own terms.',
  },
  {
    tag: 'Divine',
    color: 'blue',
    desc: 'Answer the call and change the realms for the better even without conflict.',
  },
];
